/**
 * The actions that can be taken to trigger a change in the redux store state.
 * Each one must return an object that describes the action or, if thunk is being used as middleware,
 * a function that takes a 'dispatch' argument and an optional 'getState' argument.
 * These are used in #redux.connect
 * 'dispatch' is called to trigger a specific 'action' and provide some optional data for that action.
 * These actions are handled by the 'reducers' to alter the store state
 */
import {ACTION_TYPE} from './types'

export const logout = () => ({type: ACTION_TYPE.LOGOUT})

export const changeDomain = (domain) => ( {type: ACTION_TYPE.DOMAIN_CHANGED, domain})

export const changeResourceUrl = (resourceUrl) => ( {type: ACTION_TYPE.RESOURCE_URL_CHANGED, resourceUrl})

export const changeUsername = (username) => ( {type: ACTION_TYPE.USERNAME_CHANGED, username})

export const changePassword = (password) => ( {type: ACTION_TYPE.PASSWORD_CHANGED, password})

export const changeEmail = (email) => ({type: ACTION_TYPE.EMAIL_CHANGED, email})

export const changeConfirmationCode = (confirmationCode) => ({type: ACTION_TYPE.CONFIRMATION_CODE_CHANGED, confirmationCode})

export const showModalPopup = (id) => ({type: ACTION_TYPE.OPEN_MODAL_POPUP, popup: id})

export const closeModalPopup = (id) => ({type: ACTION_TYPE.CLOSE_MODAL_POPUP, popup: id})

export const toggleDomainEdit = (domain) => ({ type: ACTION_TYPE.EDIT_DOMAIN_TOGGLE, domain })


// WEBPACK FOOTER //
// ./src/redux/actions.js